import React, { forwardRef } from 'react';
import MuiAlert, { AlertProps } from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import { useAlert } from '../../contexts';

const Alert = forwardRef<HTMLDivElement, AlertProps>((props, ref) => {
  return (
    <MuiAlert
      elevation={6}
      variant="filled"
      {...props}
      ref={ref}
      sx={{ width: '100%' }}
    />
  );
});

const CustomAlert: React.FC = () => {
  const { message, type, clearAlert } = useAlert();

  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up('md'));

  const handleClose = (
    event?: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === 'clickaway') {
      return;
    }
    clearAlert();
  };

  if (matches) {
    return (
      <Snackbar
        open={message !== ''}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        sx={{ width: '50%' }}
        autoHideDuration={6000}
      >
        <Alert onClose={handleClose} severity={type} sx={{ width: '100%' }}>
          {message}
        </Alert>
      </Snackbar>
    );
  } else {
    return (
      <Snackbar
        open={message !== ''}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={handleClose} severity={type} sx={{ width: '100%' }}>
          {message}
        </Alert>
      </Snackbar>
    );
  }
};

export default CustomAlert;
